import React from 'react';
import QuoteRequestForm, { BrochureBtn, ImgRender } from '../../BFComponents';

const Intimus32cc = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-md-3">
                    <ImgRender image={"intimus-logo-old.jpg"} cssClass={"my-2"} width={50} normal={true}/>
                    <hr className="intimusrule"></hr>  
                </div>
            </div>
            <h3>intimus 32CC3</h3>
            <div className="row">
                <div className="col-md-6 d-flex justify-content-center">
                    <ImgRender image={"32cc.jpg"} />
                </div>
                <div className="col-md-6 d-flex align-items-center">
                    <div className="align-self-center">
                        The Intimus model 32CC is designed for home or small
                        office use. It has an auto on/off and reverse in case
                        of jams. A light that indicates “Oiling Required” will
                        let the operator know when the shredder needs to
                        be oiled. The cutting cylinders are hardened steel for
                        maximum shredding. This shredder has locking casters
                        for effortless moving and stay in place operation.
                        The 32CC will shred paper, including paper clips and
                        staples, credit cards, CDs, and DVDs. Limited lifetime
                        warranty on cutting cylinders.
                        <QuoteRequestForm source={window.location} />
                        <BrochureBtn brochure={"INTIMUS 32CC3 CROSS CUT PAPER SHREDDER.pdf"} />

                    </div>
                </div>

            </div>
            <div id="jumbo32cc" className="p-2">
                <ul>
                    <li>                        Auto on/off and reverse in case of jam              </li>
                    <li>                        “Oiling Required” light to let operator know when to oil              </li>
                    <li>               Accepts paper, including paper clips and staples, credit cards, CDs, and DVDs              </li>
                </ul>
            </div>

        </div>
    )
}

export default Intimus32cc;